import { render } from "./PledgeManagerInfoFaqSection.vue?vue&type=template&id=16aef5c3"
import script from "./PledgeManagerInfoFaqSection.vue?vue&type=script&lang=js"
export * from "./PledgeManagerInfoFaqSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__